import React, { useState, useEffect } from 'react';
import ProductGrid from '../components/ProductGrid';
import CallToAction from '../components/CallToAction';
import Hero from '../components/Hero';
import './HomePage.css';

const HomePage = () => {
  const [weeklyBestSellers, setWeeklyBestSellers] = useState([]);
  const [cpuOffers, setCpuOffers] = useState([]);
  const [gabinetesOffers, setGabinetesOffers] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        // Asumimos que la respuesta de la API es un array de productos
        const response = await fetch('https://tech-market-ba-back.vercel.app/products/approved');
        const data = await response.json();
        
        setWeeklyBestSellers(data.slice(0, 5));
        setCpuOffers(data.filter(p => p.category === 'cpu').slice(0, 5));
        setGabinetesOffers(data.filter(p => p.category === 'gabinetes').slice(0, 5));

      } catch (error) {
        console.error("Error al cargar productos:", error);
      }
    };
    fetchProducts();
  }, []);

  return (
    // CAMBIO: El div de "home-container" ahora es solo "home-page"
    // y no tiene NINGÚN padding lateral.
    <div className="home-page"> 
      
      {/* El Hero ahora es HIJO DIRECTO de home-page */}
      <Hero />
      
      {/* CAMBIO: Creamos un NUEVO div para centrar
          el resto del contenido (grids, cta, etc.) */}
      <div className="home-content-container">
          <ProductGrid title="Lo más vendido de la semana" products={weeklyBestSellers} />
          
          <CallToAction 
            title="¿Tenés componentes que ya no usás?"
            text="Publicalos en Tech Market B.A y ganá dinero vendiendo a miles de personas. Es fácil, rápido y seguro."
            buttonText="Empezá a vender ahora"
            buttonLink="/product/upload"
          />

          <ProductGrid title="Ofertas de CPU" products={cpuOffers} />
          <ProductGrid title="Ofertas de Gabinetes" products={gabinetesOffers} />
      </div>

    </div>
  );
};

export default HomePage;